import { RouterProvider } from 'react-router';
import { ThemeProvider, Toaster } from '@lib/index';
import { LocaleProvider } from '@lib/locale';
import { AuthProviderWrapper } from '@lib/auth';
import { BreakpointProvider } from '@/ds/contexts/breakpoint/Provider';
import { SidebarProvider } from '@/ds/contexts/sidebar/Provider';
import router from './app/router';

function App() {
  return (
    <AuthProviderWrapper>
      <ThemeProvider>
        <LocaleProvider>
          <BreakpointProvider>
            <SidebarProvider>
              <RouterProvider router={router} />
              <Toaster />
            </SidebarProvider>
          </BreakpointProvider>
        </LocaleProvider>
      </ThemeProvider>
    </AuthProviderWrapper>
  );
}

export default App;
